
import FirstTab from "./FirstTab.vue";
import SecondTab from "./SecondTab.vue";
import ThirdTab from "./ThirdTab.vue";
export default {
  components: { FirstTab, SecondTab, ThirdTab },
  props: ["activeKey", "school_detail", "school_address", "school_infra"],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      // contacts: [
      //     {
      //         title: "Địa chỉ 1: ",
      //         content: "236B Lê Văn Sỹ, phường 1, quận Tân Bình, TP HCM",
      //         logo: "/images/Home.png"
      //     },
      //     {
      //         title: "Địa chỉ 2: ",
      //         content: "236B Lê Văn Sỹ, phường 1, quận Tân Bình, TP HCM",
      //         logo: "/images/Home.png"
      //     },
      //     {
      //         title: "Liên lạc: ",
      //         content: "028.3991.6415",
      //         logo: "/images/Home.png"
      //     },
      //     {
      //         title: "Website: ",
      //         content: "https://vanlanguni.edu.vn",
      //         logo: "/images/Home.png",
      //         isLink: true
      //     }
      // ]
    };
  },
};
